import React from "react";
import { Badge, Card, CardBody, CardHeader, Divider, HStack, Heading, Stack, Text } from "@chakra-ui/react";
import { FiAlertCircle } from "react-icons/fi";

const AlertsPanel = ({ alerts }) => {
  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <HStack justify="space-between">
          <Heading size="sm">Alerts</Heading>
          <FiAlertCircle />
        </HStack>
      </CardHeader>
      <CardBody>
        <Stack spacing={3}>
          {alerts.map((alert) => (
            <HStack key={alert.id} justify="space-between">
              <Text>{alert.label}</Text>
              <Badge colorScheme={alert.tone}>{alert.count}</Badge>
            </HStack>
          ))}
          <Divider />
          <Text fontSize="sm" color="gray.500">
            Keep an eye on refunds and canceled subscriptions to reduce churn.
          </Text>
        </Stack>
      </CardBody>
    </Card>
  );
};

export default AlertsPanel;
